import * as Api from "./Api";
export const apiFormatGet = async (url, data) => {
  try {
    const res = Api.apiCallPostFunction(
      "GET",
      `${process.env.REACT_APP_SITE_PRODUCTION_URL + url + data}`
    );

    const finaldata = await res;

    if (finaldata.data.errorCode === "200") {
      return finaldata.data;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const apiFormatPost = async (url, data) => {
  try {
    const res = Api.apiCallPostFunction(
      "POST",
      `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`,
      "application/x-www-form-urlencoded",
      data
    );

    const finaldata = await res;

    if (finaldata.data.errorCode === "200") {
      return finaldata.data;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const apiFormatForActiveServices = async (url, data) => {
  try {
    const res = Api.apiCallPostFunction(
      "GET",
      `${process.env.REACT_APP_SITE_PRODUCTION_URL + url + "/" + data}`
    );

    const finaldata = await res;

    return finaldata.data;
  } catch (e) {
    throw e;
  }
};

//api format for full controll
export const apiFormatPostFullCtrl = async (url, data) => {
  try {
    const res = Api.apiCallPostFunction(
      "POST",
      `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`,
      "application/x-www-form-urlencoded",
      data
    );

    const finaldata = await res;

    return finaldata;
  } catch (e) {
    return false;
  }
};

export const apiFormatPostFullCtrlInjson = async (url, data) => {
  try {
    const res = Api.apiCallPostFunctionJson(
      "POST",
      `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`,
      "application/json",
      data
    );

    const finaldata = await res;

    return finaldata;
  } catch (e) {
    return false;
  }
};

export const apiFormatGetFullCtrl = async (url, data) => {
  try {
    if (data) {
      const res = Api.apiCallPostFunction(
        "GET",
        `${process.env.REACT_APP_SITE_PRODUCTION_URL + url + data}`
      );

      const finaldata = await res;

      return finaldata;
    } else {
      const res = Api.apiCallPostFunction(
        "GET",
        `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`
      );

      const finaldata = await res;

      return finaldata;
    }
  } catch (e) {
    return false;
  }
};
